import { Injectable } from '@angular/core';
import { ApiService } from '@core/providers/http/api.service';
import { Observable } from 'rxjs';
import { HttpParams } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class ProfissionalEspecialidadeService {
  private readonly path = 'profissionais';

  constructor(private apiService: ApiService) {}

  list(params?: any): Observable<any> {
    return this.apiService.get(
      `${this.path}/getAllProfissionalEspecialidade`,
      this.getParams(params),
      true
    );
  }
  show(id: string): Observable<any> {
    return this.apiService.get(
      `${this.path}/getProfissionalEspecialidadeById/${id}`,
      this.getParams(),
      true
    );
  }
  add(data: any): Observable<any> {
    return this.apiService.post(
      `${this.path}/AddProfissionalEspecialidade`,
      data,
      {},
      true
    );
  }
  update(data: any): Observable<any> {
    return this.apiService.put(
      `${this.path}/UpdateProfissionalEspecialidade`,
      data,
      this.getParams(),
      true
    );
  }
  delete(id: string): Observable<any> {
    return this.apiService.delete(
      `${this.path}/DeleteProfissionalEspecialidadeById/${id}`,
      this.getParams(),
      true
    );
  }
  private getParams(params?: any): HttpParams {
    return params ? new HttpParams({ fromObject: params }) : new HttpParams();
  }
}